<script>
import Gen from "@helper/Gen.js"

export default {
  props: {
    name: String,
    attr: Object,
    option: [Boolean,String,Number,Object],
    checked: String,
    value: [Boolean,String,Number,Array, Object],
    validate: {default:""},
    disabled: Boolean,
    array: [Boolean],
    isArrayOfObjects: {
      type: Boolean,
      default: false
    },
    arrayOfObjects: Array,
    defaultAccessDoor: Array
  },
  data(){
    return{
      valueArrayOfObjects: []
    }
  },
  computed:{
    input(){      
      if(!this.array||!this.value) return this.value
      if(this.array && this.isArrayOfObjects && Array.isArray(this.value)){        
        const value = this.value.find(v => v.title == this.option.title)        
        let newValue
        if(value) {
          newValue = value.options.find(x => x == this.option.value) 
        } else {
          newValue = ""
        }        
        return newValue
      }
      if(Array.isArray(this.value)){
        const optionValue = (this.option.value||this.option)
        return this.value.indexOf(optionValue) > -1 ? optionValue : ""
      } else {
        return ""
      }
    }
  },
  methods:{
    onClick(){
      if($(this.$el).find('input').attr('disabled')) return
      if(!this.array){
        this.$emit('input', !this.input)
      }else if(this.array && !this.isArrayOfObjects){
        var values = Gen.clone(this.value)        
        if(!this.input){
          if(!Array.isArray(values)) values = []
          if(this.option.value) { 
            values.push(this.option.value)
          } else {
            values.push(this.option)             
          }
          this.$emit("input", values)
        }else{
          values.splice(values.indexOf(this.input),1)
          this.$emit("input", values)
        }
      } else if(this.array && this.isArrayOfObjects){ // Array of objects for checkbox title
          const checkArrayValues = this.value.find(v => v.title == this.option.title)
          const values = !checkArrayValues ? this.arrayOfObjects.map(v => {            
            if(v.title == 'Access Door') { 
              const options = ((this.value.find(dtValue => dtValue.title == "Access Door")||{}).options)||[]
              
              return { title: v.title, options: this.defaultAccessDoor ? [...this.defaultAccessDoor, ...options] : [] }
            }
            return { title: v.title, options: [] }
          }) : this.value;

          const existOption = values.find(v => v.title == this.option.title).options.find(x => x == this.option.value)
                                        
          if(!existOption){
            const newValues = values.map(v => {
              if(v.title == this.option.title){
                return { title: v.title, options: [...v.options, this.option.value].filter(this.onlyUnique) }
              } else {
                return { title: v.title, options: [...v.options].filter(this.onlyUnique) }
              }
            })            
            
            this.$emit("input", newValues)
          } else{
            const newValues = values.map(v => {
              if(v.title == this.option.title){
                return { title: v.title, options: [...v.options].filter(v => v != this.option.value) }
              } else {
                return { title: v.title, options: [...v.options].filter(this.onlyUnique) }
              }
            })            
            
            this.$emit("input", newValues)
          }

      }
      setTimeout(()=>$(this.$el).find("input").valid(), 10)
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },
    show(option){
      if(!option.dept_is_operation && option.facility_operation && option.facility_operation.indexOf(option.value) > -1){
        return false
      } else {
        return true
      }
    }
  },
  watch:{
    input(v){ if(!this.array) this.$emit("input", v); },
  }
}
</script>

<template>
  <span>
    <div class="inline checkbox checkbox-info" @click="onClick">
      <input type="checkbox" v-model="input" :name="name" :value="option" v-bind="attr">
      <label><slot></slot></label>
    </div>
  </span>
</template>